import React, { useEffect, useState } from 'react';

/**
 * Bouton « Voir le Commentaire » + modale de lecture.
 * (Conservé sous ce nom de fichier pour ne pas casser les imports existants.)
 */
function DropdownShowPassComment({ comment, title = null }) {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        if (!isOpen) return undefined;

        const onKeyDown = (e) => {
            if (e.key === 'Escape') setIsOpen(false);
        };
        document.addEventListener('keydown', onKeyDown);
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';

        return () => {
            document.removeEventListener('keydown', onKeyDown);
            document.body.style.overflow = prevOverflow;
        };
    }, [isOpen]);

    if (!comment) return null;

    return (
        <>
            <button
                type="button"
                className="flex items-center justify-center text-xs mr-2 text-primary-600 font-medium hover:text-primary-700"
                onClick={() => setIsOpen(true)}
            >
                <svg className="cbm9w coqgc ci53t" width={14} height={14} viewBox="0 0 16 16">
                    <path d="M8 0C3.6 0 0 3.1 0 7s3.6 7 8 7h.6l5.4 2v-4.4c1.2-1.2 2-2.8 2-4.6 0-3.9-3.6-7-8-7zm4 10.8v2.3L8.9 12H8c-3.3 0-6-2.2-6-5s2.7-5 6-5 6 2.2 6 5c0 2.2-2 3.8-2 3.8z" />
                </svg>
                <span>Voir le Commentaire</span>
            </button>

            {isOpen && (
                <div
                    className="fixed inset-0 z-[200] flex items-center justify-center bg-gray-900/40 backdrop-blur-sm p-4"
                    role="presentation"
                    onClick={() => setIsOpen(false)}
                >
                    <div
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="pass-comment-modal-title"
                        className="w-full max-w-md rounded-xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-xl"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex items-start justify-between gap-3 px-5 pt-5 pb-3">
                            <div className="min-w-0">
                                <h3
                                    id="pass-comment-modal-title"
                                    className="text-base font-bold text-gray-800 dark:text-gray-100"
                                >
                                    Commentaire du billet
                                </h3>
                                {title && (
                                    <p className="mt-0.5 text-sm text-gray-500 dark:text-gray-400 truncate">
                                        {title}
                                    </p>
                                )}
                            </div>
                            <button
                                type="button"
                                onClick={() => setIsOpen(false)}
                                className="shrink-0 rounded-lg p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 dark:hover:text-gray-200"
                                aria-label="Fermer"
                            >
                                <svg width={16} height={16} viewBox="0 0 16 16" fill="currentColor">
                                    <path d="M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z" />
                                </svg>
                            </button>
                        </div>

                        <div className="px-5 pb-2">
                            <div className="max-h-[50vh] overflow-y-auto rounded-lg border border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50 px-3.5 py-3">
                                <p className="text-sm text-gray-800 dark:text-gray-100 whitespace-pre-wrap break-words leading-relaxed">
                                    {comment}
                                </p>
                            </div>
                        </div>

                        <div className="flex justify-end px-5 py-4">
                            <button
                                type="button"
                                onClick={() => setIsOpen(false)}
                                className="inline-flex items-center px-3.5 py-2 rounded-lg text-sm font-semibold border border-gray-200 dark:border-gray-600 text-gray-800 dark:text-gray-200 bg-white dark:bg-slate-800 hover:bg-gray-50 dark:hover:bg-slate-700"
                            >
                                Fermer
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default DropdownShowPassComment;
